import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { Modal, Tooltip } from 'antd';
import { Visibility } from '@app/components';
import { Button, FormatText, FormInput, FormSelect, FormSubmitButton, MasterDetailForm, Row, Widget } from '@digital/ui';
import { getAllStatusSasPropostaOptions } from '@app/api/status';
import { validarCNPJ } from '@app/helpers/validators';
import { getByIdSasFornecedorOc, updateSasFornecedorOc } from '@app/api/sas/sasFornecedor';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { reloadState, reloadVendorListState, reloadWidgetTimelineState } from '../atoms';
import { useRecoilState } from 'recoil';

interface Props {
    sasFornecedorOcId: string;
    statusId: string;
    propostaId: string;
}

const ModalEditarVendor = (props: Props) => {
    const { sasFornecedorOcId, statusId, propostaId } = props;
    const [exibirModal, setExibirModal] = useState(false);
    const [initialValues, setInitialValues] = useState({ statusSasPropostaId: statusId });
    const [validationSchema, setValidationSchema] = useState<any>();
    const [ehInternacional, setEhInternacional] = useState(false);

    const [reloadTimeline, setReloadTimeline] = useRecoilState(reloadWidgetTimelineState);
    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
    const [reload, setReload] = useRecoilState(reloadState);

    var onReload = () => {
        setReloadTimeline(!reloadTimeline);
        setReloadVendorList(!reloadVendorList);
        setReload(!reload);
    };

    useEffect(() => {
        if (ehInternacional) {
            setValidationSchema(
                Yup.object().shape({
                    emailContato: Yup.string().required('O campo deve ser informado').email('E-mail com formato inválido.'),
                    razaoSocial: Yup.string().required('O campo deve ser informado'),
                    statusSasPropostaId: Yup.string().required('O campo deve ser informado'),
                    nomeContato: Yup.string().required('O campo deve ser informado'),
                    telefoneContato: Yup.string().required('O campo deve ser informado'),
                })
            );
        } else {
            setValidationSchema(
                Yup.object().shape({
                    cnpj: Yup.string().required('O campo deve ser informado').test('cnpj', 'CNPJ inválido.', validarCNPJ),
                    emailContato: Yup.string().required('O campo deve ser informado').email('E-mail com formato inválido.'),
                    razaoSocial: Yup.string().required('O campo deve ser informado'),
                    statusSasPropostaId: Yup.string().required('O campo deve ser informado'),
                    nomeContato: Yup.string().required('O campo deve ser informado'),
                    telefoneContato: Yup.string().required('O campo deve ser informado'),
                })
            );
        }
    }, [ehInternacional]);


    useEffect(() => {
        if (exibirModal && sasFornecedorOcId) {
            getByIdSasFornecedorOc(sasFornecedorOcId).then(data => {
                if (data) {
                    setEhInternacional(!(isObjNotEmpty(data.cnpj) && validarCNPJ(data.cnpj)));

                    setInitialValues({ ...initialValues, ...data });
                }
            });
        }
    }, [exibirModal, sasFornecedorOcId]);


    const onSubmit = (values: any) => {
        values.id = sasFornecedorOcId;
        values.propostaId = propostaId;

        updateSasFornecedorOc(values).then(data => {
            if (data) {
                if (data.valid) {
                    onReload();
                    setExibirModal(false);
                }
            }
        });
    };


    return (
        <>
            <Tooltip title="Editar" >
                <Button key="vendorListEdit" icon="editing-pencil" onClick={() => setExibirModal(true)} />
            </Tooltip>
            <Visibility visible={exibirModal}>

                <Modal
                    title="Editar Vendor List"
                    width="980px"
                    visible={exibirModal}
                    onCancel={() => setExibirModal(false)}
                    footer={null}
                >
                    <MasterDetailForm
                        key="formEditVendor"
                        initialValues={initialValues}
                        onSubmit={onSubmit}
                        validationSchema={validationSchema}
                        actions={[
                            <Button
                                type="link"
                                onClick={() => {
                                    setExibirModal(false);
                                }}
                                key="close">
                                Fechar
                            </Button>,
                            <FormSubmitButton noIcon type="primary">
                                <FormatText id="ui.commons.save" uppercase />
                            </FormSubmitButton>,
                        ]}
                    >
                        <Widget>
                            <Row>
                                <FormInput label="Código Totvs" name="codigoTotvs" span={3} disabled />
                                <FormInput label="CNPJ" name="cnpj" span={3} />
                                <FormInput label="Razão Social" name="razaoSocial" span={6} disabled />
                            </Row>
                            <Row>
                                <FormInput label="E-mail Fornecedor" name="emailContato" span={8} />
                                <FormSelect
                                    label="Status desta Cotação"
                                    getOptions={getAllStatusSasPropostaOptions}
                                    name="statusSasPropostaId"
                                    span={4}
                                    disabled
                                />
                            </Row>
                            <Row>
                                <FormInput label="Nome Contato" name="nomeContato" span={8} />
                                <FormInput label="Telefone Contato" name="telefoneContato" span={4} />
                            </Row>
                        </Widget>
                    </MasterDetailForm>
                </Modal>
            </Visibility>
        </>
    );
};

export default ModalEditarVendor;